import { render, staticRenderFns } from "./License.vue?vue&type=template&id=077f7c7a&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"
import style0 from "./License.vue?vue&type=style&index=0&id=077f7c7a&lang=scss&scoped=true&"
import style1 from "./License.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f7c7a",
  null
  
)

export default component.exports